<template>
  <img-wrapper
    v-if="display_block"
    :src="contact_photo"
    srcset
    :width="size"
    :height="size"
    @error="onImageError"
  >
    <template #placeholder>
      <!--
        <v-row
        class="fill-height ma-0"
        align="center"
        justify="center"
        >
        <v-progress-circular
        indeterminate
        color="#5e81f4"
        />
        </v-row>
      -->
    </template>
  </img-wrapper>
</template>

<script>
import ImgWrapper from './ImgWrapper';

const not_found_default_male_logo = require("@/assets/images/nds/male_avatar_round.svg");
const not_found_default_female_logo = require("@/assets/images/nds/female_avatar_round.svg");

const contact_photo_url_prefix = 'https://storage.googleapis.com/static-portraits-nomination/mini/';
const contact_photo_extention = 'jpg';

export default {
  name: 'ContactPhoto',
  components: {
    ImgWrapper,
  },
  props: {
    civility_id: [Number, String],
    contact_id: [Number, String],
    inactive_contact: {
      default: false,
      type: Boolean,
    },
    size: {
      type: [Number, String],
      default: null,
    },
    use_avatar: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    let contact_photo = null;

    if (this.inactive_contact) {
      contact_photo = this.pickDefaultContactPhoto();
    } else {
      contact_photo = `${contact_photo_url_prefix}${this.contact_id}.${contact_photo_extention}`;
    }

    return {
      contact_photo,
      display_block: true,
      display_avatar: true,
    };
  },
  mounted() {
    if (this.use_avatar !== undefined) {
      this.display_avatar = this.use_avatar;
    }
  },
  methods: {
    onImageError() {
      if (this.display_avatar === false) {
        this.display_block = false;
      }

      this.contact_photo = this.pickDefaultContactPhoto();
    },
    pickDefaultContactPhoto() {
      return (this.civility_id == 1 || this.civility_id === undefined)
        ? not_found_default_male_logo
        : not_found_default_female_logo;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(img) {
  border-radius: 50%;
  object-fit: cover;
}
</style>
